import api from "./api";

class PermissionService {
  async getItems(data) {
    const response = await api.get("/permission/item/list", { params: data });
    return response;
  }

  async getDataPage(data) {
    if (data.type === 'group') {
      return await this.getGroups(data);
    }
    if (data.type === 'item') {
      return await this.getItems(data);
    }
  }

  async getGroups(data) {
    const response = await api.get("/permission/group/list", { params: data });
    return response;
  }

  async updateOrCreateItem(item) {
    if (item.id) {
      const response = await api.put(`/permission/item/create/${item.id}`, item);
      return response;
    }
    const response = await api.post("/permission/item/create", item);
    return response;
  }

  async changeStatus(item) {
    if (item.params.type === 'group') { 
        return await this.updateOrCreateGroup(item);
    }
    return await this.updateOrCreateItem(item);
  }

  async updateOrCreateGroup(item) {
    if (item.id) {
      const response = await api.put(`/permission/group/create/${item.id ?? ''}`, item);
      return response;
    }
    const response = await api.post("/permission/group/create", item);
    return response;
  }

  async destroyGroup(id) {
    const response = await api.delete(`/permission/group/delete/${id}`);
    return response;
  }

  async destroy(id) {
    const response = await api.delete(`/permission/item/delete/${id}`);
    return response;
  }
}

export default new PermissionService();
